import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.scss";
import { MemberContext } from "../Contexts/MemberContext";

const Navbar = () => {
  const [menuActive, setMenuActive] = useState(false);
  const navigate = useNavigate();
  const { currentUserInfo, membersLoading, currentUser } =
    useContext(MemberContext);

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  const closeMenu = () => {
    setMenuActive(false);
  };

  const isAdmin = currentUserInfo?.administrator === true;
  const safeAuthorId = currentUserInfo?.author?.id;

  const handleButtonClick = (id) => {
    if (!currentUserInfo || !safeAuthorId) return;

    if (safeAuthorId === id || isAdmin) {
      navigate(`/membercreate`, { state: { authorId: id } });
    } else {
      alert("詳細は本人と管理者だけが閲覧や編集できます。");
    }
  };

  useEffect(() => {
    let timer;
    if (menuActive) {
      timer = setTimeout(() => setMenuActive(false), 5000);
    }
    return () => clearTimeout(timer);
  }, [menuActive]);

  return (
    <nav className="navbar">
      <div className="circleName">ライジング</div>

      {/* スマホ表示用 */}
      <div
        className="navbar_accunt_name_narrow"
        onClick={() => {
          if (currentUserInfo) {
            handleButtonClick(safeAuthorId);
          } else {
            navigate("/login");
          }
        }}
      >
        {currentUserInfo ? currentUserInfo.accountname : "ゲスト"} さん
      </div>

      <div className="menu-icon" onClick={toggleMenu}>
        &#9776;
      </div>

      <ul className={`nav-links ${menuActive ? "active" : ""}`}>
        {/* メンバー共通 */}
        <li onClick={closeMenu}>
          <Link to="/">ホーム</Link>
        </li>
        <li onClick={closeMenu}>
          <Link to="/memberlist">メンバー</Link>
        </li>
        <li onClick={closeMenu}>
          <Link to="/postlist">ブログ等</Link>
        </li>
        <li onClick={closeMenu}>
          <Link to="/aboutus">会の紹介</Link>
        </li>
        <li onClick={closeMenu}>
          <Link to="/calendar">カレンダー</Link>
        </li>
        <li onClick={closeMenu}>
          <Link to="/eventlist">イベント</Link>
        </li>
        <li onClick={closeMenu}>
          <Link to="/links">リンク</Link>
        </li>

        {/* 管理者だけ */}
        {isAdmin && (
          <>
            <li onClick={closeMenu}>
              <Link to="/management">管理</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/emailsenderselect">メール送信</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/test">テスト</Link>
            </li>
          </>
        )}

        {/* ログイン / ログアウト */}
        {!currentUserInfo ? (
          <li onClick={closeMenu}>
            <Link to="/login">ログイン</Link>
          </li>
        ) : (
          <li onClick={closeMenu}>
            <Link to="/logout">ログアウト</Link>
          </li>
        )}
      </ul>

      {/* PC表示 */}
      <div className="account-name" onClick={closeMenu}>
        {membersLoading ? null : !currentUserInfo ? (
          <span onClick={() => navigate("/login")}>ログインしてください</span>
        ) : (
          <span
            className="navbar-accountname"
            onClick={() => handleButtonClick(safeAuthorId)}
          >
            {currentUserInfo.accountname} さん
          </span>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
